import * as yup from "yup";

export const loginValidationSchema = yup.object().shape({
  email: yup.string().email("Invalid email type").required("Email is required"),
  password: yup
    .string()
    .min(8, "Password length is too small")
    .required("Password is required"),
});

export const forgetPassValidationSchema = yup.object().shape({
  email: yup.string().email("Invalid email type").required("Email is required"),
});
